import { render, staticRenderFns } from "./HeatCAD.vue?vue&type=template&id=dc0f7b5c&scoped=true"
import script from "./HeatCAD.vue?vue&type=script&lang=js"
export * from "./HeatCAD.vue?vue&type=script&lang=js"
import style0 from "./HeatCAD.vue?vue&type=style&index=0&id=dc0f7b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f7b5c",
  null
  
)

export default component.exports
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPageSticky,QBtn});
